import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Banner from "./components/Banner";
import Area1 from "./components/Area1";
import Area2 from "./components/Area2";
import GridWithCentralArea from "./components/GridWithCentralArea";
import GridWithBottomArea from "./components/GridWithBottomArea"; // Layout basato sull'immagine
import "./App.css";
import { TotemProvider } from "./components/TotemContext";
import { MenuProvider } from "./components/MenuContext";

function App() {
  const [searchParams] = useSearchParams();
  const [config, setConfig] = useState("1");
  const [activeButton, setActiveButton] = useState(null);
  const [iframeUrl, setIframeUrl] = useState("");
  const [activeContent, setActiveContent] = useState(""); // Contenuto attivo da mostrare nell'area centrale

  // Recupera configurazione da GET
  useEffect(() => {
    const configParam = searchParams.get("config");
    if (configParam) setConfig(configParam);
  }, [searchParams]);

  // 🛑 BLOCCO ZOOM E TASTO DESTRO 🛑
  useEffect(() => {
    // Imposta il meta tag viewport per disabilitare lo zoom
    const metaTag = document.createElement("meta");
    metaTag.name = "viewport";
    metaTag.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
    document.head.appendChild(metaTag);
  
    // Funzione di utilità per verificare se l'evento proviene da un elemento editabile
    const isEditable = (target) => {
      const tag = target.tagName.toLowerCase();
      return tag === "input" || tag === "textarea" || target.isContentEditable;
    };
  
    // Disabilita lo zoom con la rotellina del mouse (Ctrl + Scroll)
    const handleWheel = (event) => {
      if (isEditable(event.target)) return; // Non bloccare se l'evento proviene da un campo editabile
      if (event.ctrlKey) {
        event.preventDefault(); // Blocca lo zoom con Ctrl + Scroll
      }
    };
  
    // Disabilita lo zoom con Ctrl + "+" o "-"
    const handleKeyDown = (event) => {
      if (isEditable(event.target)) return; // Non bloccare se l'evento proviene da un campo editabile
      if (event.ctrlKey && (event.key === "+" || event.key === "-")) {
        // Permettiamo lo zoom tramite combinazione da tastiera in altri contesti se lo desideri
        return;
      }
      event.preventDefault(); // Blocca tutte le altre combinazioni
    };
  
    // Disabilita il pinch-to-zoom su touchscreen
    const handleGesture = (event) => {
      if (isEditable(event.target)) return; // Lascia passare l'evento per i campi editabili
      event.preventDefault(); // Blocca il pinch-to-zoom
    };
  
    // Aggiunge gli event listener
    document.addEventListener("wheel", handleWheel, { passive: false });
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("gesturestart", handleGesture);
  
    // Blocca il tasto destro (context menu)
    const handleRightClick = (event) => {
      event.preventDefault();
    };
    document.addEventListener("contextmenu", handleRightClick);
  
    // Cleanup: rimuove gli event listener quando il componente si smonta
    return () => {
      document.removeEventListener("wheel", handleWheel);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("gesturestart", handleGesture);
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);


  // ✅ VERSION CHECK massimo 2 volte al giorno
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const now = Date.now();
        const lastCheck = parseInt(localStorage.getItem("lastVersionCheck") || "0", 10);

        // se meno di 12 ore fa (43200000 ms), non controllare
        if (now - lastCheck < 12 * 60 * 60 * 1000) {
          console.log("⏳ Salto controllo versione: ultima verifica recente.");
          return;
        }

        // aggiorna timestamp del controllo
        localStorage.setItem("lastVersionCheck", now.toString());

        // fai la richiesta
        const res = await fetch('https://api.psicopatici.com/api/version-totem', { cache: "no-store" });
        if (!res.ok) return console.error("Errore recupero versione");

        const data = await res.json(); // es: { version: "1.0.3" }
        const remoteVersion = data.version;
        const localVersion = localStorage.getItem("appVersion");

        if (localVersion !== remoteVersion) {
          console.log(`🔄 Version update: ${localVersion} -> ${remoteVersion}`);
          localStorage.setItem("appVersion", remoteVersion);
          window.location.href = window.location.href; // preserva query params
        } else {
          console.log("✅ Versione già aggiornata:", remoteVersion);
        }
      } catch (err) {
        console.error("Errore durante il check della versione:", err);
      }
    };

    checkVersion();
  }, []);



  // Gestione del click sul pulsante
  const handleButtonClick = (button) => {
    setActiveButton(button.id);
    setIframeUrl(button.content);
  };

  // Rendering in base alla configurazione
  return (
    <div className="app-layout">
      <TotemProvider>
        <MenuProvider>
          {config === "1" ? (
            <GridWithBottomArea
              onBannerClick={(content) => setActiveContent(content)}
              activeContent={activeContent}
            />
          ) : (
            <GridWithCentralArea
              onBannerClick={(content) => setActiveContent(content)}
              activeContent={activeContent}
            />
          )}
        </MenuProvider>
      </TotemProvider>
    </div>
  );
}

export default App;
